/* eslint-disable */
import services from 'services';

export default {
  fetchRolePermissions: async ({ commit }) => {
    const permissions = await services.permissionService.fetchRolePermissions();
    console.log('permissionService', permissions);
    commit('SET_ROLE_PERMISSIONS', permissions);
  },
};
